<template>
  <div class="relative flex flex-col">
    <div v-if="label">
      <label
        :for="label"
        class="text-text-primary text-sm font-medium dark:text-dark-secondary"
        :class="[labelClass, allowLabelWrap ? '' : 'label-wrapper']"
      >
        {{ label }}
        <span v-if="required" class="ml-1">
          (Obligatorio)<span class="text-text-error">*</span>
        </span>
      </label>
    </div>

    <MultiSelect
      v-model="model"
      :options="options"
      :optionLabel="optionLabel"
      :optionValue="optionValue"
      :placeholder="placeholder"
      class="items-center dark:bg-surface-primary! dark:placeholder-dark-secondary! dark:border-dark-border! dark:text-dark-secondary!"
      :class="{ 'border-helper-text!': error, [selectClass]: true }"
      @change="$emit('change', $event)"
    />

    <div class="h-4 mt-1 relative">
      <transition name="fade">
        <p
          v-if="error"
          class="absolute left-0 top-0 text-helper-text text-[11px] leading-3 flex items-center gap-1"
        >
          <font-awesome-icon
            icon="fa-solid fa-circle-xmark"
            class="text-helper-text mr-1"
          />
          {{ error }}
        </p>
      </transition>
    </div>
  </div>
</template>

<script setup>
const model = defineModel();

const props = defineProps({
  options: {
    type: Array,
    default: [],
  },
  optionLabel: {
    type: String,
    default: null,
  },
  optionValue: {
    type: String,
    default: null,
  },
  placeholder: {
    type: String,
    default: "Seleccione una opción",
  },
  selectClass: {
    type: String,
    default: "",
  },
  error: {
    type: String,
    default: "",
  },
  labelClass: {
    type: String,
    default: "",
  },
  size: {
    type: String,
    default: "",
  },
  label: {
    type: String,
    required: false,
    default: "",
  },
  required: {
    type: Boolean,
    default: true,
  },
  filter: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  isMyAccount: {
    type: Boolean,
    default: false,
    required: false,
  },
  customOption: {
    type: Boolean,
    default: false,
    required: false,
  },
  baseUrl: {
    type: String,
  },
  allowLabelWrap: {
    type: Boolean,
    default: false,
  },
});

const emits = defineEmits(["change"]);
</script>
